export const doDateRangesIntersect = (
  range1Start: string,
  range1End: string,
  range2Start: string,
  range2End: string,
): boolean => {
  return (range1Start <= range2End && range1End >= range2Start) || (range2Start <= range1End && range2End >= range1Start);
};
